import { IGetItemsResult } from '../types/IGetItemsResult';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export interface IAssociateOAuthCredentialParams extends IGetItemsResult {
  credentialId: string;   // ID of the OAuth Credential to be used.
  resourceId: string;     // ID of the workbook or datasource to use the keychain.
  resourceType: string;   // "Workbook" or "Datasource"
}

export class AssociateOAuthCredentialRequest extends Request<IAssociateOAuthCredentialParams, IEmptyResult> {
  constructor(params: IAssociateOAuthCredentialParams) {
    super('associateOAuthCredential', params);
  }
}
